/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Click_Or_Drag_Private_Photos_HInputs */

const en_click_or_drag_private_photos_h = /** @type {(inputs: Click_Or_Drag_Private_Photos_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click or drag private photos, PDFs, or EPUBs here`)
};

const es_click_or_drag_private_photos_h = /** @type {(inputs: Click_Or_Drag_Private_Photos_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haz clic o arrastra fotos privadas aquí`)
};

const fr_click_or_drag_private_photos_h = /** @type {(inputs: Click_Or_Drag_Private_Photos_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cliquez ou glissez les photos privées ici`)
};

const de_click_or_drag_private_photos_h = /** @type {(inputs: Click_Or_Drag_Private_Photos_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private Fotos hier klicken oder ablegen`)
};

const ja_click_or_drag_private_photos_h = /** @type {(inputs: Click_Or_Drag_Private_Photos_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プライベートな写真をここへクリックまたはドラッグ`)
};

const zh_click_or_drag_private_photos_h = /** @type {(inputs: Click_Or_Drag_Private_Photos_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`点击或拖拽私人照片至此处`)
};

const ar_click_or_drag_private_photos_h = /** @type {(inputs: Click_Or_Drag_Private_Photos_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`انقر أو اسحب الصور الخاصة هنا`)
};

const id_click_or_drag_private_photos_h = /** @type {(inputs: Click_Or_Drag_Private_Photos_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klik atau seret foto pribadi, PDF, atau EPUB ke sini`)
};

const it_click_or_drag_private_photos_h = /** @type {(inputs: Click_Or_Drag_Private_Photos_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clicca o trascina qui le foto private`)
};

const ru_click_or_drag_private_photos_h = /** @type {(inputs: Click_Or_Drag_Private_Photos_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Нажмите или перетащите сюда личные фотографии`)
};

const pt_click_or_drag_private_photos_h = /** @type {(inputs: Click_Or_Drag_Private_Photos_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clique ou arraste fotos privadas aqui`)
};

const ko_click_or_drag_private_photos_h = /** @type {(inputs: Click_Or_Drag_Private_Photos_HInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`여기를 클릭하거나 비공개 사진을 드래그하세요`)
};

/**
* | output |
* | --- |
* | "Click or drag private photos, PDFs, or EPUBs here" |
*
* @param {Click_Or_Drag_Private_Photos_HInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const click_or_drag_private_photos_h = /** @type {((inputs?: Click_Or_Drag_Private_Photos_HInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Click_Or_Drag_Private_Photos_HInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_click_or_drag_private_photos_h(inputs)
	if (locale === "es") return es_click_or_drag_private_photos_h(inputs)
	if (locale === "fr") return fr_click_or_drag_private_photos_h(inputs)
	if (locale === "de") return de_click_or_drag_private_photos_h(inputs)
	if (locale === "ja") return ja_click_or_drag_private_photos_h(inputs)
	if (locale === "zh") return zh_click_or_drag_private_photos_h(inputs)
	if (locale === "ar") return ar_click_or_drag_private_photos_h(inputs)
	if (locale === "id") return id_click_or_drag_private_photos_h(inputs)
	if (locale === "it") return it_click_or_drag_private_photos_h(inputs)
	if (locale === "ru") return ru_click_or_drag_private_photos_h(inputs)
	if (locale === "pt") return pt_click_or_drag_private_photos_h(inputs)
	return ko_click_or_drag_private_photos_h(inputs)
});